import { Flex } from 'foundations-components/components/Flex';
import { DEFAULT_LIMIT } from '../constants/filters';
import { InboxNavTicketRow } from './InboxNavTicketRow';
import { InboxNavTicketRowSkeleton } from './InboxNavTicketRowSkeleton';
import { TicketListEmptyState } from './TicketListEmptyState';
import { jsx as _jsx } from "react/jsx-runtime";
export function InboxNavTicketList({
  tickets,
  loading,
  error
}) {
  if (loading) {
    return /*#__PURE__*/_jsx(Flex, {
      flexDirection: "column",
      role: "list",
      children: Array.from({
        length: DEFAULT_LIMIT
      }).map((_, i) => /*#__PURE__*/_jsx(InboxNavTicketRowSkeleton, {}, i))
    });
  }
  if (!tickets || tickets.length === 0) {
    return /*#__PURE__*/_jsx(TicketListEmptyState, {
      error: error,
      headingTypography: "heading-100",
      trackingScreen: "ticket-details-inbox-nav"
    });
  }
  return /*#__PURE__*/_jsx(Flex, {
    flexDirection: "column",
    role: "list",
    children: tickets.map(ticket => /*#__PURE__*/_jsx(InboxNavTicketRow, {
      ticket: ticket
    }, ticket.hs_ticket_id))
  });
}